import { css } from '@emotion/react';

export const branchListLoadingCss = {
  block: css`
    display: block;
    margin: 32px auto;
  `,
};
